import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = ({ storeName, parentStoreName }) => {
    const dynaSelectors = dynaForms.getSelectors(storeName);
    const parentSelector = dynaForms.getSelectors(parentStoreName);

    return {
        ...dynaSelectors,
        parent: parentSelector,
    };
};

export default getSelectors;
